export default {
  spacing: {
    display: 'block',
    width: '100%',
    height: '20px'
  }
};
